module.exports = __webpack_public_path__ + "img/nav_logo_1.68e5c1fc.jpg";